import React from 'react';
import { sendSentryMessage } from '../../utils/sentry-helper';

interface IProps {
	children: React.ReactElement;
}

export default class ErrorBoundary extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): { hasError: boolean } {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(e): void {
		sendSentryMessage({ name: `Error Boundary`, context: e });
		// You can also log the error to an error reporting service
		this.setState({ hasError: false });
		// history.push('/error');
		if (window.location.href !== ('/error')) {
			window.location.href = ('/error');
		}
	}

	render(): React.ReactElement {
		return this.props.children;
	}
}
